'use strict';

var PropTypes = require('prop-types');

module.exports = {
  propTypes: {
    xAccessor: PropTypes.func,
    yAccessor: PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      xAccessor: function xAccessor(d) {
        return d.x;
      },
      yAccessor: function yAccessor(d) {
        return d.y;
      }
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rd3/build/cjs/mixins/DefaultAccessorsMixin.js
// module id = 362
// module chunks = 0